import { Controller } from "@hotwired/stimulus"
import { getMonthNames } from "../utils/calendar_constants"

// Manages the year view of the calendar
export default class extends Controller {
  static targets = ["title", "grid"]
  static values = {
    events: Array
  }
  
  connect() {
    this.currentYear = new Date().getFullYear()
    this.render()
  }
  
  previousYear() {
    this.currentYear -= 1
    this.render()
  }
  
  nextYear() {
    this.currentYear += 1
    this.render()
  }
  
  render() {
    // Update title
    this.titleTarget.textContent = String(this.currentYear)
    
    // Count events per month
    const monthNames = getMonthNames()
    const counts = new Array(12).fill(0)
    
    this.eventsValue.forEach(e => {
      if (!e.event_date) return
      const d = new Date(e.event_date)
      if (d.getFullYear() === this.currentYear) {
        counts[d.getMonth()] += 1
      }
    })
    
    // Render month grid
    this.gridTarget.innerHTML = monthNames.map((name, i) => `
      <button
        data-month-index="${i}"
        data-action="click->calendar-year-view#selectMonth"
        class="bz-cal-monthtile">
        <div>
          <div class="bz-cal-monthtile__name">${name}</div>
          <div class="bz-cal-monthtile__count">${counts[i]} event${counts[i] === 1 ? '' : 's'}</div>
        </div>
        <svg class="bz-cal-monthtile__chev" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    `).join('')
  }
  
  selectMonth(event) {
    const monthIndex = parseInt(event.currentTarget.getAttribute('data-month-index'))
    const target = new Date(this.currentYear, monthIndex, 1)
    const qs = `?month=${target.getFullYear()}-${String(target.getMonth() + 1).padStart(2, '0')}-01`
    
    // Switch to month view and navigate
    this.dispatch('switch-to-month', { detail: { queryString: qs } })
  }
}

